
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.648 1.351a1 1 0 01.565-.04l.139.04 7.667 2.884a1 1 0 01.64.813l.008.123v10.136a1 1 0 01-.277.691l-.095.087-7.67 6.192a1 1 0 01-1.152.073l-.103-.073-7.67-6.192a1 1 0 01-.364-.65l-.008-.128V5.171a1 1 0 01.535-.885l.113-.05 7.672-2.885zM11.232 5l-.01 5.881a3.5 3.5 0 101.757.052V8.65H14.5a.2.2 0 00.2-.2V7.107a.2.2 0 00-.2-.2L12.98 6.9V5a.2.2 0 00-.2-.2h-1.348a.2.2 0 00-.2.2zM12 12.65a1.5 1.5 0 110 3 1.5 1.5 0 010-3z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    